export function useGitlabService() {
  const fetchFile = (api: string, file: string) => {
    const url = `/rest/statics-resources/${file}?api=${api}`;

    return fetch(url);
  };

  return { fetchFile };
}
